// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"be659fae","39":"b35fc2dd","58":"ef86941b","91":"e95dbc22","140":"306e91e4","172":"b03eb9dc","185":"0b65f429","219":"983ab18c","415":"367748d7","437":"f571fb5c","479":"af8d6684","495":"8e7e7f3b","924":"fb603992","975":"79d91d60","988":"16ccf7bf"}[chunkId] + ".chunk.js";
};